/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect } from "react";
import { useChainlitStore } from "@/store/zustand/useChainlitStore";
import {
  sessionState,
  useChatData,
  useChatInteract,
  useChatSession,
} from "@chainlit/react-client";
import { copilot } from "@/api";
import { useUserStore } from "@/store/zustand/useUserStore";
import { useRecoilValue } from "recoil";
import ChainlitModal from "./ChainlitModal";

const userEnv = {};

const ChainlitProvider = ({
  children
}) => {
  const user = useUserStore((state) => state.user);
  const { connect, disconnect } = useChatSession();
  const session = useRecoilValue(sessionState);
  const { loading } = useChatData();
  const { clear } = useChatInteract();
  const { expanded, setExpanded, expandedMessage, setToken } = useChainlitStore(
    (state) => state
  );
  const closeModal = useCallback(() => setExpanded(false), []);

  useEffect(() => {
    if (!user) {
      clear();
      disconnect();
    } else {
      copilot
        .token()
        .then(({ data }) => {
          const headers = new Headers();
          headers.append("Authorization", `Bearer ${data.data.access_token}`);
          fetch(import.meta.env.VITE_CHAINLIT_AUTH_URL, {
            credentials: "include",
            headers,
          }).then(() => {
            connect({
              userEnv,
            });
          });
        })
        .catch(() => {
          /**
           * do nothing
           */
        });
    }
  }, [user]);

  return (
    <>
      {children}
      <ChainlitModal
        visible={expanded}
        close={closeModal}
        expandedMessage={expandedMessage}
        loading={loading}
      />
    </>
  );
};

export default ChainlitProvider;
